import { render, staticRenderFns } from "./LogecExport.vue?vue&type=template&id=582c16f8"
import script from "./LogecExport.vue?vue&type=script&lang=js"
export * from "./LogecExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports